import { internalMessageBus, InternalMessageBusChannels } from "sb-internal-msg-bus";
import { BetslipUtilChannels } from "sb-betslip-utils-contracts";
export class MessageBus {
    constructor(topicPrefix, context) {
        this.listeners = {};
        this.globalListeners = {};
        this.bus = internalMessageBus;
        this.topicPrefix = topicPrefix;
        this.context = context;
        this.addFilterListeners();
        this.addLegacyListeners();
        this.addGlobalListeners();
        this.addBetslipListeners();
    }
    addFilterListeners() {
        Object.keys(InternalMessageBusChannels.eventsFilter).forEach(key => {
            this.context[`${key}Change`] && (this.listeners[InternalMessageBusChannels.eventsFilter[key]] = `${key}Change`);
        });
    }
    addGlobalListeners() {
        this.globalListeners[InternalMessageBusChannels.legacy.timeZone.update] = "timeZoneChange";
        this.globalListeners[InternalMessageBusChannels.legacy.oddStyle.update] = "oddStyleChange";
        this.globalListeners[InternalMessageBusChannels.legacy.userInfo.onLogin] = "onLogin";
        this.globalListeners[InternalMessageBusChannels.legacy.userInfo.onLogout] = "onLogout";
        this.globalListeners[InternalMessageBusChannels.legacy.platformJWTChange.renewJWTToken] = "renewJWTToken";
        this.globalListeners[InternalMessageBusChannels.legacy.betslip.items.add] = "betSlipItemsAdd";
        this.globalListeners[InternalMessageBusChannels.legacy.betslip.items.remove] = "betSlipItemsRemove";
    }
    addBetslipListeners() {
        this.globalListeners[BetslipUtilChannels.Broadcast.Status] = "betSlipStatusReceived";
        this.globalListeners[BetslipUtilChannels.Broadcast.Items.added] = "betslipAddedItemsReceived";
        this.globalListeners[BetslipUtilChannels.Broadcast.Items.removed] = "betslipRemovedItemsReceived";
        this.globalListeners[BetslipUtilChannels.Broadcast.Items.cleared] = "betslipClearedItemsReceived";
    }
    addLegacyListeners() {
        this.listeners[InternalMessageBusChannels.legacy.eventCard.changedToSide] = "changedToSide";
        this.listeners[InternalMessageBusChannels.legacy.filter.events.none] = "allEventsChange";
        this.listeners[InternalMessageBusChannels.legacy.filter.events.liveStream] = "liveStreamingChange";
        this.listeners[InternalMessageBusChannels.legacy.filter.events.fastMaskets] = "fastMarketsChange";
        this.listeners[InternalMessageBusChannels.legacy.activeEvent.update] = "activeEventIdChange";
    }
    msgRouter(msg) {
        const handler = this.listeners[`${msg.channel}.${msg.subChannel.join(".")}`.replace(this.topicPrefix, "")];
        this.context[handler] && this.context[handler](...msg.data);
    }
    msgRouterGlobal(msg) {
        const handler = this.globalListeners[`${msg.channel}.${msg.subChannel.join(".")}`];
        this.context[handler] && this.context[handler](...msg.data);
    }
    attachListeners() {
        Object.keys(this.listeners).forEach(x => this.bus.on(`${this.topicPrefix}${x}`, this.msgRouter, this));
        Object.keys(this.globalListeners).forEach(x => this.bus.on(x, this.msgRouterGlobal, this));
    }
    dettachListeners() {
        Object.keys(this.listeners).forEach(x => this.bus.off(`${this.topicPrefix}${x}`, this.msgRouter, this));
        Object.keys(this.globalListeners).forEach(x => this.bus.off(x, this.msgRouterGlobal, this));
    }
    requestGlobalListeners(timeZoneChangeHandler, oddStyleChangeHandler, onLoginHandler) {
        internalMessageBus.emit(InternalMessageBusChannels.legacy.timeZone.request, { callback: timeZoneChangeHandler });
        internalMessageBus.emit(InternalMessageBusChannels.legacy.oddStyle.request, { callback: oddStyleChangeHandler });
        internalMessageBus.emit(InternalMessageBusChannels.legacy.userInfo.request, { callback: onLoginHandler });
    }
    sendBsUtilStatusMessage() {
        this.bus.emit(BetslipUtilChannels.Listen.Commands.get_status);
    }
    sendBsUtilItemsAddMessage(data) {
        this.bus.emit(BetslipUtilChannels.Listen.Commands.add_items, data);
    }
    sendBsUtilItemsRemoveMessage(data) {
        this.bus.emit(BetslipUtilChannels.Listen.Commands.remove_items, data);
    }
    sendEventCountMessage(eventsCount, sportId) {
        this.bus.emit(`${this.topicPrefix}${InternalMessageBusChannels.eventsList.count}`, { eventsCount, sportId });
    }
    sendActiveEventMessage(eventId, isOutright) {
        this.bus.emit(`${this.topicPrefix}${InternalMessageBusChannels.legacy.activeEvent.init}`, { eventId, isOutright });
    }
    sendLastActiveEventMessage(id, mode) {
        this.bus.emit(`${this.topicPrefix}${InternalMessageBusChannels.legacy.activeEvent.updateLast}`, { id, mode });
    }
    sendTagsMessage(message) {
        this.bus.emit(`${this.topicPrefix}${InternalMessageBusChannels.eventsList.tags}`, message);
    }
    sendLiveStreamMessage(eventId) {
        this.bus.emit(InternalMessageBusChannels.legacy.liveStream.update, parseInt(eventId));
    }
}
//# sourceMappingURL=MessageBus.js.map